import React, { useContext, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useLocalStore, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import ExamStore from 'stores/Exam';
import { storesContext } from 'stores';
import CatalogCard from 'components/Catalog/Card';

const ExamCard = (props) => {
  const { catalogStore } = useContext(storesContext);
  const { entry } = props;
  const store = useLocalStore(() => new ExamStore(catalogStore));
  const changeVersion = (newVersion) => {
    store.version = newVersion;
  };
  const versions = Object.keys(
    catalogStore.groupedCatalogEntries[entry.code] || { 1: {} },
  );
  const { offering } = store;
  const { t } = useTranslation();

  useEffect(() => {
    const { version } = entry;
    store.version = version;
    store.code = entry.code;
    store.getUserExam();
  }, []);

  // eslint-disable-next-line camelcase
  const status = store.userExam?.retake_index
    ? `${t(store.status.replaceAll('_', ' '))} (${t('Retake')})`
    : t(store.status.replaceAll('_', ' '));

  return offering ? (
    <CatalogCard
      displayVersionDropdown
      versions={versions}
      course={offering}
      status={status}
      key={entry.code}
      onVersionChange={changeVersion}
    />
  ) : null;
};

ExamCard.propTypes = {
  entry: PropTypes.object,
};

ExamCard.defaultProps = {
  entry: {},
};

export default observer(ExamCard);
